// Modules
import { ReactElement } from "react"
import Skeleton, { SkeletonProps } from "react-loading-skeleton"

interface SkeletonWrapperProps extends SkeletonProps {
  isLoading: boolean
  children?: ReactElement
}

const SkeletonWrapper = ({
  isLoading,
  children,
  ...props
}: SkeletonWrapperProps) => {
  if (isLoading) {
    return <Skeleton {...props} />
  }
  return <>{children}</>
}

export default SkeletonWrapper
